import { createReducer, on } from '@ngrx/store';
import * as VenueActions from './venue.actions';
import { Venue } from './venue.models';

// ----------------------------------------------------------------------
// @ State
// ----------------------------------------------------------------------

export interface VenuesState {
    venues: Venue[];
    venue: Venue;
    isLoading: boolean;
    error: string | null;
}

// ----------------------------------------------------------------------
// @ Initial State
// ----------------------------------------------------------------------

export const initialVenuesState: VenuesState = {
    venues: [],
    venue: null,
    isLoading: false,
    error: null,
};

// ----------------------------------------------------------------------
// @ Reducers
// ----------------------------------------------------------------------

// All Venues Reducer
export const venuesReducer = createReducer(
    initialVenuesState,

    // On Load Venues
    on(VenueActions.loadVenues, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(VenueActions.loadVenuesSuccess, (state, { venues }) => ({
        ...state,
        isLoading: false,
        venues: venues,
    })),
    on(VenueActions.loadVenuesFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Create
    on(VenueActions.createVenue, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(VenueActions.createVenueSuccess, (state, { venue }) => ({
        ...state,
        isLoading: false,
        venues: [...(state.venues || []), venue],
    })),
    on(VenueActions.createVenueFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Update
    on(VenueActions.updateVenue, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(VenueActions.updateVenueSuccess, (state, { venue }) => ({
        ...state,
        isLoading: false,
        venues: state.venues.map((v) => (v.id === venue.id ? venue : v)),
        venue: venue,
    })),
    on(VenueActions.updateVenueFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Delete
    on(VenueActions.deleteVenue, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(VenueActions.deleteVenueSuccess, (state, { id }) => ({
        ...state,
        isLoading: false,
        venues: state.venues.filter((v) => v.id !== id),
    })),
    on(VenueActions.deleteVenueFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Load Single Venue
    on(VenueActions.loadVenue, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(VenueActions.loadVenueSuccess, (state, { venue }) => ({
        ...state,
        isLoading: false,
        venue: venue,
    })),
    on(VenueActions.loadVenueFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Create Venue Success, Store the Venue
    on(VenueActions.createVenueSuccess, (state, { venue }) => ({
        ...state,
        isLoading: false,
        venue: venue,
    })),

    // On Set Venue
    on(VenueActions.setCurrentVenue, (state, { venue }) => ({
        ...state,
        isLoading: false,
        venue: venue,
    }))
);
